export enum WsFontSize {
  BODY_S = '12px',
  BODY_M = '14px',
  BODY_L = '16px',
  HEADING_XXS = '12px',
  HEADING_xs = '14px',
  HEADING_S = '16px',
  HEADING_M = '20px',
  HEADING_L = '24px',
  HEADING_XL = '28px',
  HEADING_XXL = '32px',
}

export enum WsFontWeight {
  REGULAR = 500,
  MEDIUM = 600,
  SEMI_BOLD = 700,
  BOLD = 800,
}

export enum WsIconSize {
  SMALL = 12,
  MEDIUM = 14,
  LARGE = 16,
}

export enum WsBadgeSize {
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export const WsBadgeProps: Record<WsBadgeSize, WsBadgeSizeProps> = {
  MEDIUM: {
    badgeHeight: WsFontSize.HEADING_S,
    textSize: WsFontSize.BODY_S,
    startIconSize: WsIconSize.SMALL,
    endIconSize: WsIconSize.MEDIUM,
  },
  LARGE: {
    badgeHeight: WsFontSize.HEADING_L,
    textSize: WsFontSize.BODY_M,
    startIconSize: WsIconSize.MEDIUM,
    endIconSize: WsIconSize.LARGE,
  },
};

interface WsBadgeSizeProps {
  badgeHeight: string;
  textSize: string;
  startIconSize: number;
  endIconSize: number;
}

export enum WsColorsNew {
  GreenDark = '#065F46',

  TheBlues950 = '#337ab7',
  TheBlues900 = '#03045E',
  TheBlues800 = '#023E8A',
  TheBlues750 = ' #0C66E4',
  TheBlues700 = '#0077B6',
  TheBlues600 = '#0096C7',
  TheBlues500 = '#00B4D8',
  TheBlues400 = '#48CAE4',
  TheBlues300 = '#90E0EF',
  TheBlues200 = '#ADE8F4',
  TheBlues100 = '#CAF0F8',
  TheBlues50 = '#F2FBFD',
  TheBlues75 = '#E5F9FB',
  TheBlues25 = '#FAFAFC',

  danger_50 = '#fef2f2',
  danger_100 = '#fee2e2',
  danger_200 = '#fecaca',
  danger_300 = '#fca5a5',
  danger_400 = '#f87171',
  danger_500 = '#ef4444',
  danger_600 = '#dc2626',
  danger_700 = '#b91c1c',
  danger_800 = '#991b1b',
  danger_900 = '#7f1d1d',
  danger_950 = '#450a0a',

  indigo_10 = '#eef2ff',
  indigo_100 = '#e0e7ff',
  indigo_200 = '#c7d2fe',
  indigo_300 = '#a5b4fc',
  indigo_400 = '#818cf8',
  indigo_500 = '#6366f1',
  indigo_600 = '#4f46e5',
  indigo_700 = '#4338ca',
  indigo_800 = '#3730a3',
  indigo_900 = '#312e81',
  indigo_950 = '#1e1b4b',

  information_50 = '#eff6ff',
  information_100 = '#dbeafe',
  information_200 = '#bfdbfe',
  information_300 = '#93c5fd',
  information_400 = '#60a5fa',
  information_500 = '#3b82f6',
  information_600 = '#0c66e4',
  information_700 = '#1d4ed8',
  information_800 = '#1e40af',
  information_900 = '#1e3a8a',
  information_950 = '#172554',

  lime_50 = '#f7fee7',
  lime_100 = '#ecfccb',
  lime_200 = '#d9f99d',
  lime_300 = '#bef264',
  lime_400 = '#a3e635',
  lime_500 = '#84cc16',
  lime_600 = '#65a30d',
  lime_700 = '#4d7c0f',
  lime_800 = '#3f6212',
  lime_900 = '#365314',
  lime_950 = '#1a2e05',

  neutral_10 = '#ffffff',
  neutral_50 = '#f0f2f3',
  neutral_100 = '#e8edee',
  neutral_200 = '#d1d7d8',
  neutral_200a = '#d1d7d8',
  neutral_300 = '#b3bcbe',
  neutral_300a = '#b3bcbe',
  neutral_400 = '#8b9ca1',
  neutral_400a = '#9eadb2',
  neutral_400aa = '#9eadb2',
  neutral_500 = '#77949a',
  neutral_600 = '#5c757d',
  neutral_700 = '#3f5660',
  neutral_800 = '#2e454b',
  neutral_900 = '#0d2e36',
  neutral_950 = '#051a20',
  neutral_1000 = '#000000',

  orange_10 = '#fff7ed',
  orange_100 = '#ffedd5',
  orange_200 = '#fed7aa',
  orange_300 = '#fdba74',
  orange_400 = '#fb923c',
  orange_500 = '#f97316',
  orange_600 = '#ea580c',
  orange_700 = '#c2410c',
  orange_800 = '#9a3412',
  orange_900 = '#78350f',
  orange_950 = '#431407',

  purple_50 = '#fdf4ff',
  purple_100 = '#fae8ff',
  purple_200 = '#f5d0fe',
  purple_300 = '#f0abfc',
  purple_400 = '#e879f9',
  purple_500 = '#d946ef',
  purple_600 = '#c026d3',
  purple_700 = '#a21caf',
  purple_800 = '#86198f',
  purple_900 = '#701a75',
  purple_950 = '#4a044e',

  success_50 = '#f0fdf4',
  success_100 = '#dcfce7',
  success_200 = '#bbf7d0',
  success_300 = '#86efac',
  success_400 = '#4ade80',
  success_500 = '#22c55e',
  success_600 = '#16a34a',
  success_700 = '#15803d',
  success_800 = '#166534',
  success_900 = '#14532d',
  success_950 = '#052e16',

  warning_50 = '#fefce8',
  warning_100 = '#fef9c3',
  warning_200 = '#fef08a',
  warning_300 = '#fde047',
  warning_400 = '#facc15',
  warning_500 = '#eab308',
  warning_600 = '#ca8a04',
  warning_700 = '#a16207',
  warning_800 = '#854d0e',
  warning_900 = '#713f12',
  warning_950 = '#422006',

  border_selected = '#0891B2',
  text_brand_color = '#0E7490',
  brand_light_pressed_25 = '#A5F3FC40',
}

interface IWsBadgeType {
  textColor: string;
  backgroundColor: string;
}

export enum WsBadgetype {
  SUCCESS = 'SUCCESS',
  INACTIVE = 'INACTIVE',
  INPROGRESS = 'INPROGRESS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  INITIATED = 'INITIATED',
  PRIORITY = 'PRIORITY',
  REOPENED = 'REOPENED',
  WARNING = 'WARNING',
  SPECIAL = 'SPECIAL',
  FILTER_ACTIVE = 'FILTER_ACTIVE',
  FILTER_INACTIVE = 'FILTER_INACTIVE',
}

export const WsBadgeTypeProps: Record<WsBadgetype, IWsBadgeType> = {
  SUCCESS: { textColor: WsColorsNew.success_900, backgroundColor: WsColorsNew.success_100 },
  INACTIVE: { textColor: WsColorsNew.neutral_900, backgroundColor: WsColorsNew.neutral_100 },
  INPROGRESS: {
    textColor: WsColorsNew.information_900,
    backgroundColor: WsColorsNew.information_100,
  },
  FAILED: { textColor: WsColorsNew.danger_600, backgroundColor: WsColorsNew.danger_100 },
  PENDING: { textColor: WsColorsNew.warning_700, backgroundColor: WsColorsNew.warning_100 },
  INITIATED: { textColor: WsColorsNew.purple_700, backgroundColor: WsColorsNew.purple_100 },
  PRIORITY: { textColor: WsColorsNew.lime_700, backgroundColor: WsColorsNew.lime_100 },
  REOPENED: { textColor: WsColorsNew.indigo_700, backgroundColor: WsColorsNew.indigo_100 },
  WARNING: { textColor: WsColorsNew.orange_700, backgroundColor: WsColorsNew.orange_100 },
  SPECIAL: { textColor: WsColorsNew.TheBlues700, backgroundColor: WsColorsNew.TheBlues100 },
  FILTER_ACTIVE: { textColor: WsColorsNew.TheBlues500, backgroundColor: WsColorsNew.neutral_10 },
  FILTER_INACTIVE: { textColor: WsColorsNew.neutral_900, backgroundColor: WsColorsNew.neutral_10 },
};
